export interface IPharmaceuticalForm {
    pharmaceuticalFormId: string,
    code: string,
    descriptionEnglish: string,
    descriptionArabic: string,
}

export const pharmaceuticalFormConfig = {
    entityName: 'CONFIGURATION.PHARMACEUTICAL_FORM.TITLE',
    descriptionEnglish: 'FORM_FIELD.ENGLISH_NAME',
    descriptionArabic: 'FORM_FIELD.ARABIC_NAME',
    code: 'FORM_FIELD.CODE'
};